import { render, staticRenderFns } from "./priceListConfigList.vue?vue&type=template&id=b0566882&"
import script from "./priceListConfigList.vue?vue&type=script&lang=js&"
export * from "./priceListConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports